import { processClinicalQAReports } from "../api/clinicalQa"
import { useMutation } from "@tanstack/react-query"

export const useProcessClinicalQAReports = () =>
  useMutation({
    mutationFn: processClinicalQAReports,
  })
